<mat-icon
  [matTooltipPosition]="'above'"
  matTooltip="{{ showTooltip ? (tooltipText | translate) : null }}"
  aria-hidden="false"
  aria-label="calculated icon"
  [ngClass]="{ 'light-dark': state === 1, warning: state === 2, error: state === 3 }"
  class="calculated-icon"
  >{{ iconName }}</mat-icon
>
